import { render, staticRenderFns } from "./termo-aceitacao-modal.vue?vue&type=template&id=79365166&scoped=true"
import script from "./termo-aceitacao-modal.vue?vue&type=script&lang=js"
export * from "./termo-aceitacao-modal.vue?vue&type=script&lang=js"
import style0 from "./termo-aceitacao-modal.vue?vue&type=style&index=0&id=79365166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79365166",
  null
  
)

export default component.exports